BryanAnthonys.loadedScripts['engravables'] = true;

(() => {
    const engravableBuilders = document.querySelectorAll('engravable-builder');
    if (window.location.href.includes('/products/') && engravableBuilders.length === 1) {
        const engravableBuilder = engravableBuilders[0];
        const engravableBuilderModal = engravableBuilder.querySelector('modal-dialog');
        engravableBuilder.addEventListener('engravableVariantChanged', event => {
            const variant = event.detail.variant;
            if (!variant) {
                return;
            }

            if (engravableBuilderModal.hasAttribute('open')) {
                variant.options.forEach((option, index) => {
                    const position = index + 1;
                    const pdpSwatch = document.querySelector(
                        `product-section [data-picker-fieldset][data-position="${position}"] input[value=${JSON.stringify(option)}]`
                    );
                    if (pdpSwatch) {
                        pdpSwatch.click();
                    }
                });
            }
        });

        document.addEventListener('productVariantChanged', event => {
            const variant = event.detail.variant;
            if (!variant || engravableBuilderModal.hasAttribute('open')) {
                return;
            }

            variant.options.forEach((option) => {
                const builderSwatch = engravableBuilder.querySelector(
                    `swatch-group [data-value=${JSON.stringify(option)}]`
                );
                if (builderSwatch) {
                    builderSwatch.click();
                }
            });
        });
    }

    if (window.location.href.indexOf('#debug') !== -1 && !document.querySelector('engravable-debugger')) {
        document.querySelectorAll('engravable-preview').forEach(engravablePreview => {
            engravablePreview.insertAdjacentHTML('beforeend', '<engravable-debugger></engravable-debugger>');
        });
    }
})();

class EngravableBuilder extends HTMLElement {
    connectedCallback() {
        this.addEventListener('engravableConfigLoaded', () => this.activate());

        this.addEventListener('engravableOptionsChanged', event => {
            if (event.detail.options.noEngraving) {
                this.classList.add('engravable-builder--no-engraving');
            } else {
                this.classList.remove('engravable-builder--no-engraving');
            }
        });

        document.addEventListener('modalDialogShown', event => {
            if (event.target.id === 'ProductCustomizer' && event.target.closest('engravable-builder') === this) {
                document.dispatchEvent(new CustomEvent('engravablePopupOpened', {
                    detail: {builderId: this.id}
                }));
            }
        });
    }

    activate() {
        this.product = JSON.parse(this.querySelector('[data-product]').innerHTML);
        this.variant = this.product.variants.find(variant => parseInt(this.dataset.variantId) === variant.id);
        this.fonts = JSON.parse(this.querySelector('[data-fonts-urls]').innerHTML);

        this.config = JSON.parse(this.querySelector('[data-product-config]').innerHTML);
        if (!this.config) {
            this.showMissingConfigWarning();

            return;
        }

        this.addEventListener('engravableVariantChanged', event => {
            if (event.detail.variant) {
                this.changeVariant(event.detail.variant);
            }
        });

        this.id = `builder-${this.dataset.handle}-${Math.floor(Math.random() * 1000)}`;
    }

    changeVariant(variant) {
        this.variant = variant;
        this.dataset.variantId = variant.id;
    }

    showMissingConfigWarning() {
        const message = 'The engravable builder could not be initialized because the product lacks the necessary config data';

        if (!this.dataset.initErrorSelector) {
            console.error(message);
        }

        document.querySelector(this.dataset.initErrorSelector).insertAdjacentHTML('beforeend', `
            <div class="status-banner status-banner--error mb-1" aria-live="polite">${message}</div>
        `);
    }

    debug(message, context) {
        if (this.getDebugger()) {
            this.getDebugger().debug(message, context);
        }
    }

    getDebugger() {
        if (!this.debugger) {
            this.debugger = this.querySelector('engravable-debugger');
        }

        return this.debugger;
    }

    getFontUrl(fontName) {
        return this.fonts[fontName];
    }

    getSourceConfig(variant) {
        const variantHandle = BryanAnthonys.handleize(variant ? variant.title : this.variant.title);

        return this.config.images.find(image => image.key === variantHandle);
    }
}

customElements.define('engravable-builder', EngravableBuilder);

class EngravableDebugger extends HTMLElement {
    connectedCallback() {
        const builder = this.closest('engravable-builder');
        builder.addEventListener('engravableOptionsComputed', this.debugComputedOptions.bind(this));

        this.addEventListener('click', event => {
            if (event.target.hasAttribute('data-download-preview-image')) {
                return this.downloadRenderingImage('[data-preview-canvas]');
            }

            if (event.target.hasAttribute('data-download-rendering-image')) {
                return this.downloadSvgRenderingImage('[data-svg-rendering]');
            }
        });

        this.addEventListener('change', event => {
            const className = `engravable-builder--${event.target.name}`;
            if (event.target.checked) {
                builder.classList.add(className);
            } else {
                builder.classList.remove(className);
            }
        });
    }

    debug(message, context) {
        const logger = console.warn || console.log;
        logger(message, context);
    }

    debugComputedOptions(event) {
        this.debug('computed options', event.detail.computedOptions);

        this.querySelectorAll('[data-compute-options-debug]').forEach(el => el.remove());

        const acceptedText = event.detail.acceptedText;
        const options = event.detail.computedOptions;

        this.insertAdjacentHTML('afterbegin', BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(`
            <div class="status-banner mt-3" data-compute-options-debug>
                <div><strong>Debugging data (temporary)</strong></div>
                Text height: ${acceptedText.size.size}" <br/>
                Font: ${options.styles.font},  color ${options.styles.fillStyle}<br/>
                <label class="custom-checkbox size-14 mt-2">
                  <input type="checkbox" name="reveal-outline-canvas">
                  <span class="custom-checkbox__checkmark"></span>
                  <span class="custom-checkbox__text">Show outline canvas</span>
                </label>
                <label class="custom-checkbox size-14 mt-2">
                  <input type="checkbox" name="hide-preview-canvas">
                  <span class="custom-checkbox__checkmark"></span>
                  <span class="custom-checkbox__text">Hide preview canvas</span>
                </label>
                <button type="button" data-download-preview-image class="button button--tiny mt-2">Download preview image</button>
                <button type="button" data-download-rendering-image class="button button--tiny mt-2">Download rendering image</button>
            </div>
        `)));
    }

    downloadRenderingImage(canvasSelector) {
        const link = document.createElement('a');
        link.download = `engravable-${canvasSelector.replace('[', '').replace(']', '').replace('data-', '')}.png`;
        link.href = this.closest('engravable-builder')
            .querySelector('engravable-preview')
            .querySelector(canvasSelector)
            .toDataURL();
        link.click();
    }

    downloadSvgRenderingImage(elementSelector) {
        const link = document.createElement('a');
        const svg = this.closest('engravable-builder').querySelector(elementSelector).innerHTML;
        link.download = `engravable-${elementSelector.replace('[', '').replace(']', '').replace('data-', '')}.svg`;
        link.href = URL.createObjectURL(
            new Blob([svg], {type: 'image/svg+xml'})
        );
        link.click();
    }
}

customElements.define('engravable-debugger', EngravableDebugger);

customElements.define('engravable-config-loaded', class extends HTMLElement {
    connectedCallback() {
        this.closest('engravable-builder').dispatchEvent(new CustomEvent('engravableConfigLoaded'));
    }
});

class EngravableSvgRenderer {
    constructor(builder) {
        this.builder = builder;
    }

    render(options, computedOptions, renderingElement, template) {
        BryanAnthonys.textToSvg.load(
            this.builder.getFontUrl(computedOptions.font.family),
            (error, textToSVG) => {
                this.renderSvg(error, renderingElement, computedOptions, textToSVG, template);
            }
        );
    }

    renderSvg(error, renderingElement, computedOptions, textToSVG, template) {
        if (error) {
            renderingElement.innerHTML = '';
            console.log(error);
        } else {
            const options = {
                fontSize: computedOptions.font.size,
                anchor: 'left top',
                attributes: {
                    fill: 'black'
                }
            };

            const svgPath = textToSVG.getPath(computedOptions.text, options);
            const svg = textToSVG.getSVG(computedOptions.text, options);

            const sizes = this.measureSvg(svg);
            const sourceConfig = this.builder.getSourceConfig();

            const svgLeftCenter = sourceConfig.svgLeftCenter || 0.5;
            const svgTopCenter = sourceConfig.svgTopCenter || 0.5;

            const left = (sourceConfig.pendantPixelsWidth * svgLeftCenter) - (sizes.width / 2);
            const top = (sourceConfig.pendantPixelsHeight * svgTopCenter) - (sizes.height / 2);

            renderingElement.innerHTML = BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(template.replace(
                '[TEXT]',
                svgPath.replace('<path ', `<path transform="translate(${left},${top})" `)
            )));

            const percentageWidth = (sourceConfig.pendantPixelsWidth / sourceConfig.width) * 100;
            renderingElement.style.width = `${percentageWidth}%`;
            const percentageMarginLeft = ((sourceConfig.blankPixelsLeft || 0) / sourceConfig.width) * 100;
            renderingElement.style.marginLeft = `${percentageMarginLeft}%`;
            const percentageMarginTop = ((sourceConfig.blankPixelsTop || 0) / sourceConfig.width) * 100;
            renderingElement.style.marginTop = `${percentageMarginTop}%`;
        }
    }

    measureSvg(svg) {
        const wrapper = document.createElement('div');
        wrapper.style.opacity = 0;
        wrapper.innerHTML = BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(svg));
        document.body.appendChild(wrapper);
        const svgElement = wrapper.querySelector('svg');
        const width = svgElement.clientWidth;
        const height = svgElement.clientHeight;
        wrapper.remove();

        return {width, height};
    }
}

class LoveCompassSvgRenderer extends EngravableSvgRenderer {
    renderSvg(error, renderingElement, computedOptions, textToSVG, template) {
        if (error) {
            renderingElement.innerHTML = '';
            console.log(error);
        } else {
            const options = {
                fontSize: computedOptions.font.size,
                anchor: 'left top',
                attributes: {
                    fill: 'black'
                }
            };

            const svgPaths = computedOptions.cardinals.map(cardinal => {
                const svgPath = textToSVG.getPath(cardinal.character, options);

                const svg = textToSVG.getSVG(cardinal.character, options);
                const sizes = this.measureSvg(svg);

                const left = cardinal.svgX - (sizes.width / 2);
                const top = cardinal.svgY - (sizes.height / 2);

                return svgPath.replace('<path ', `<path transform="translate(${left},${top})" `);
            });

            renderingElement.innerHTML = BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(
                template.replace('[TEXT]', svgPaths.join(''))
            ));

            const sourceConfig = this.builder.getSourceConfig();
            const percentageWidth = (sourceConfig.pendantPixelsWidth / sourceConfig.width) * 100;
            renderingElement.style.width = `${percentageWidth}%`;
            const percentageMarginLeft = ((sourceConfig.blankPixelsLeft || 0) / sourceConfig.width) * 100;
            renderingElement.style.marginLeft = `${percentageMarginLeft}%`;
            const percentageMarginTop = ((sourceConfig.blankPixelsTop || 0) / sourceConfig.width) * 100;
            renderingElement.style.marginTop = `${percentageMarginTop}%`;
        }
    }
}

class EngravableSvgRendering extends HTMLElement {
    connectedCallback() {
        this.closest('engravable-preview').addEventListener(
            'engravablePreviewDrawn',
            event => this.render(event.detail.options, event.detail.computedOptions)
        );

        this.builder = this.closest('engravable-builder');
        this.renderer = this.makeRenderer(this.builder);
    }

    render(options, computedOptions) {
        const renderingElement = this.getSvgRenderingWrapper();
        const template = this.querySelector('[data-svg-template]').innerHTML;

        if (options.noEngraving) {
            renderingElement.innerHTML = BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(
                template.replace('[TEXT]', '')
            ));

            return;
        }

        this.renderer.render(options, computedOptions, renderingElement, template);
    }

    getSvgRenderingWrapper() {
        return this.querySelector('[data-svg-rendering]');
    }

    makeRenderer(builder) {
        switch (builder.config.svgRenderer) {
            case 'love-compass':
                return new LoveCompassSvgRenderer(builder);
            default:
                return new EngravableSvgRenderer(builder);
        }
    }
}

customElements.define('engravable-svg-rendering', EngravableSvgRendering);

class EngravablePreviewRenderer {
    constructor(engravablePreview, canvas, textTester = null) {
        this.engravablePreview = engravablePreview;
        this.canvas = canvas;
        this.context2D = this.canvas.getContext("2d");
        this.textTester = textTester;
    }

    render(options, sourceImage, sourceConfig) {
        this.canvas.width = sourceImage.naturalWidth;
        this.canvas.height = sourceImage.naturalHeight;
        this.context2D.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.context2D.drawImage(sourceImage, 0, 0);
        this.context2D.textBaseline = 'middle';

        let computedOptions = null;
        const shouldDrawEngraving = !options.noEngraving;
        if (shouldDrawEngraving) {
            computedOptions = this.computeOptions(options, sourceConfig);

            for (const prop in computedOptions.styles) {
                this.context2D[prop] = computedOptions.styles[prop];
            }

            this.context2D.fillText(
                computedOptions.text,
                computedOptions.coords.x,
                computedOptions.coords.y
            );
        }

        this.engravablePreview.dispatchEvent(new CustomEvent('engravablePreviewDrawn', {
            detail: {options, computedOptions}
        }));
    }

    computeOptions(options, sourceConfig) {
        const acceptedText = this.textTester.prepareAcceptableText(options.text, options.fontConfig, sourceConfig);

        let topCoord = sourceConfig.pendantCenterPixelsTop;
        if (acceptedText.size.verticalAdjustment > 0) {
            topCoord += Math.round((topCoord * acceptedText.size.verticalAdjustment) / 100);
        }

        let fillStyle = sourceConfig.textColor;
        if (options.fontConfig.textColorOverwrite && options.fontConfig.textColorOverwrite[sourceConfig.key]) {
            fillStyle = options.fontConfig.textColorOverwrite[sourceConfig.key];
        }

        const computedOptions = {
            text: acceptedText.spacedText,
            coords: {
                x: sourceConfig.pendantCenterPixelsLeft,
                y: topCoord
            },
            styles: {
                font: `${acceptedText.size.fontWeight} ${acceptedText.pixelsSize}px ${options.fontConfig.family}`,
                fillStyle,
                textAlign: "center"
            },
            font: {
                size: acceptedText.pixelsSize,
                family: options.fontConfig.family,
                weight: acceptedText.size.fontWeight
            }
        };

        this.engravablePreview.dispatchEvent(new CustomEvent('engravableOptionsComputed', {
            bubbles: true,
            detail: {acceptedText, computedOptions, options}
        }));

        return computedOptions;
    }
}

class LoveCompassPreviewRenderer extends EngravablePreviewRenderer {
    render(options, sourceImage, sourceConfig) {
        this.canvas.width = sourceImage.naturalWidth;
        this.canvas.height = sourceImage.naturalHeight;
        this.context2D.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.context2D.drawImage(sourceImage, 0, 0);
        this.context2D.textBaseline = 'middle';

        let computedOptions = null;
        const shouldDrawEngraving = !options.noEngraving;
        if (shouldDrawEngraving) {
            computedOptions = this.computeOptions(options, sourceConfig);

            for (const prop in computedOptions.styles) {
                this.context2D[prop] = computedOptions.styles[prop];
            }

            computedOptions.cardinals.forEach(cardinalOptions => {
                this.context2D.fillText(
                    cardinalOptions.character,
                    cardinalOptions.x,
                    cardinalOptions.y
                );
            });
        }

        this.engravablePreview.dispatchEvent(new CustomEvent('engravablePreviewDrawn', {
            detail: {options, computedOptions}
        }));
    }

    computeOptions(options, sourceConfig) {
        const fontSize = options.fontConfig.sizes[0];
        const pixelToInchRatio = sourceConfig.pendantPixelsWidth / sourceConfig.pendantInchesWidth;
        const pixelsSize = Math.round((fontSize.size * pixelToInchRatio) / (options.fontConfig.heightRenderingPercentage / 100));
        const acceptedText = {
            acceptedText: options.text,
            spacedText: options.text,
            size: fontSize,
            pixelsSize
        };

        const fontWeight = acceptedText.size.fontWeight;

        const cardinals = options.text.split(', ').map((cardinalCharacter, index) => {
            const cardinals = ['N', 'E', 'S', 'W'];
            const {x, y} = sourceConfig.pixelCoords[cardinals[index]];
            const {svgX, svgY} = sourceConfig.svgPixelCoords
                ? sourceConfig.svgPixelCoords[cardinals[index]]
                : sourceConfig.pixelCoords[cardinals[index]];

            return {character: cardinalCharacter, x, y, svgX, svgY};
        });

        const computedOptions = {
            text: options.text,
            styles: {
                font: `${fontWeight} ${pixelsSize}px ${options.fontConfig.family}`,
                fillStyle: sourceConfig.textColor,
                textAlign: "center"
            },
            font: {
                size: pixelsSize,
                family: options.fontConfig.family,
                weight: fontWeight
            },
            cardinals
        };

        this.engravablePreview.dispatchEvent(new CustomEvent('engravableOptionsComputed', {
            bubbles: true,
            detail: {acceptedText, computedOptions, options}
        }));

        return computedOptions;
    }
}

class EngravablePreview extends HTMLElement {
    connectedCallback() {
        this.builder = this.closest('engravable-builder');
        this.sourceConfig = this.builder.getSourceConfig();
    }

    initialize() {
        this.sourceImage = this.querySelector('img[data-preview-source]');
        this.options = this.querySelector('[data-engravable-builder-options]');
        this.engravablePreviewRenderer = this.makeRenderer();

        this.setLoadingState();

        this.addEventListener(
            'engravableOptionsChanged',
            event => this.asyncRender(event.detail.options)
        );

        this.builder.addEventListener('engravableVariantChanged', event => {
            if (event.detail.variant) {
                this.changeSource(event.detail.variant);
                this.asyncRender(this.options.getValues());
            }
        });

        this.addEventListener('engravablePreviewDrawn', () => this.removeLoadingState());
    }

    asyncRender(options) {
        this.ensureSourceIsLoaded()
            .then(
                () => this.engravablePreviewRenderer.render(options, this.sourceImage, this.sourceConfig)
            );
    }

    ensureSourceIsLoaded() {
        return new Promise((resolve) => {
            if (this.sourceImage.complete) {
                resolve();
            } else {
                this.sourceImage.onload = resolve;
            }
        });
    }

    changeSource(variant) {
        this.setLoadingState();

        this.sourceConfig = this.builder.getSourceConfig(variant);
        this.sourceImage.src = this.sourceConfig.src;
    }

    setLoadingState() {
        this.classList.add('engravable-preview--loading');
    }

    removeLoadingState() {
        this.classList.remove('engravable-preview--loading');
    }

    makeRenderer() {
        const canvas = this.querySelector('canvas[data-preview-canvas]');
        const textTester = this.querySelector('engravable-text-tester');

        switch (this.builder.config.previewRenderer) {
            case 'love-compass':
                return new LoveCompassPreviewRenderer(this, canvas);
            default:
                return new EngravablePreviewRenderer(this, canvas, textTester);
        }
    }
}

customElements.define('engravable-preview', EngravablePreview);

class EngravableTextTester extends HTMLElement {
    connectedCallback() {
        this.builder = this.closest('engravable-builder');
        this.preview = this.closest('engravable-preview');

        this.style.lineHeight = '1';
        this.style.position = 'absolute';
        this.style.background = '#f2aaaa';
        this.style.color = 'black';
        this.style.whiteSpace = 'nowrap';
        this.style.left = '0';
        this.style.bottom = '0';
        this.style.opacity = '0';
        this.style.pointerEvents = 'none';
    }

    prepareAcceptableText(originalText, fontConfig, sourceConfig) {
        this.style.fontFamily = fontConfig.family;
        const pixelToInchRatio = sourceConfig.pendantPixelsWidth / sourceConfig.pendantInchesWidth;
        let maxWidth = Math.round(sourceConfig.textSpaceInchesWidth * pixelToInchRatio);
        let maxHeight = Math.round(sourceConfig.textSpaceInchesHeight * pixelToInchRatio);

        let acceptedText = this.processHardLimits(originalText, fontConfig);
        let match = null;

        while (!(match = this.findTextSizeMatch(acceptedText, maxWidth, maxHeight, pixelToInchRatio, fontConfig))) {
            acceptedText = acceptedText.slice(0, -1);
            if (!acceptedText) {
                throw "Could not find a matching font size";
            }
        }

        this.builder.debug('Found text size match', {match, maxWidth, maxHeight, arguments});

        return match;
    }

    findTextSizeMatch(acceptedText, maxWidth, maxHeight, pixelToInchRatio, fontConfig) {
        for (const size of fontConfig.sizes) {
            const pixelsSize = Math.round((size.size * pixelToInchRatio) / (fontConfig.heightRenderingPercentage / 100));
            if (pixelsSize > maxHeight) {
                continue;
            }

            const spacedText = this.getSpacedText(acceptedText, size.spacer);

            this.innerText = spacedText;
            this.style.lineHeight = 1;
            this.style.fontWeight = size.fontWeight;
            this.style.fontSize = `${pixelsSize}px`;

            const boundingClientRect = this.getBoundingClientRect();

            let rectWidth = boundingClientRect.width;
            let rectHeight = boundingClientRect.height;
            if (size.measurementBufferX) {
                rectWidth += rectWidth * (size.measurementBufferX / 100);
            }
            if (size.measurementBufferY) {
                rectHeight += rectHeight * (size.measurementBufferY / 100);
            }

            if (rectWidth >= maxWidth || rectHeight > maxHeight) {
                continue;
            }

            return {acceptedText, spacedText, size, pixelsSize};
        }

        return null;
    }


    getSpacedText(text, spacer) {
        if (!spacer) {
            return text;
        }

        return text.split("").join(String.fromCharCode(spacer));
    }

    processHardLimits(originalText, fontConfig) {
        const hardLimit = fontConfig.hardLimit;

        if (originalText.length <= hardLimit) {
            return originalText;
        }

        let acceptedText = originalText.trim();

        if (acceptedText.length <= hardLimit) {
            return acceptedText;
        }

        if (this.stringCouldBeDate(acceptedText)) {
            const dateWithoutDots = acceptedText.replaceAll('.', '');
            if (dateWithoutDots.length <= hardLimit) {
                return acceptedText;
            }
        }

        return acceptedText.slice(0, hardLimit);
    }

    stringCouldBeDate(string) {
        const groups = string.split('.');
        if (groups.length !== 3 || groups[0].length > 2 || groups[1].length > 2 || groups[2].length > 4) {
            return false;
        }

        for (const group of groups) {
            const characters = group.split('');
            for (const character of characters) {
                if (character != parseInt(character)) {
                    return false;
                }
            }
        }

        return true;
    }
}

customElements.define('engravable-text-tester', EngravableTextTester);

class EngravableOptions extends HTMLElement {
    connectedCallback() {
        this.preview = this.closest('engravable-preview');
        this.builder = this.closest('engravable-builder');

        this.triggerPreviewChange = () => this.dispatchEvent(new CustomEvent('engravableOptionsChanged', {
            bubbles: true,
            detail: {options: this.getValues()}
        }));
        this.updateText = this.updateText.bind(this);
    }

    initialize() {
        this.textOption = this.querySelector('[data-engravable-text]');
        this.fontOptions = this.querySelectorAll('[data-font-option]');
        this.noEngravingOption = this.querySelector('[data-no-egraving]');

        const debouncedTriggerPreviewChange = BryanAnthonys.debounce(this.triggerPreviewChange, 300);
        this.textOption.addEventListener('input', event => {
            this.updateText(event.target.value);
            debouncedTriggerPreviewChange();
        });

        this.textOption.addEventListener('change', event => {
            this.updateText(event.target.value);
            this.triggerPreviewChange();
        });

        this.preview.addEventListener('engravableOptionsComputed', event => {
            if (event.detail.acceptedText.acceptedText !== this.textOption.value) {
                this.textOption.value = event.detail.acceptedText.acceptedText;
                if (!this.textOption.classList.contains('engravable-options__text-input--updated')) {
                    this.textOption.classList.add('engravable-options__text-input--updated');
                    setTimeout(() => this.textOption.classList.remove('engravable-options__text-input--updated'), 1000);
                }
            }
        });

        this.fontOptions.forEach(fontOption => fontOption.addEventListener('change', () => {
            this.setFontConfig();
            this.updateText(this.textOption.value);
            this.triggerPreviewChange();
        }));

        if (this.noEngravingOption) {
            this.noEngravingOption.addEventListener('change', () => {
                const noEngravingClass = 'engravable-options--no-engraving';
                if (this.noEngravingIsChecked()) {
                    this.classList.add(noEngravingClass);
                } else {
                    this.classList.remove(noEngravingClass);
                }

                this.triggerPreviewChange();
            });
        }

        document.addEventListener('engravablePopupOpened', event => {
            if (event.detail.builderId === this.builder.id) {
                const update = () => {
                    this.setFontConfig();
                    this.updateText(this.textOption.value);
                    this.triggerPreviewChange();
                };
                update();

                if (!document.fonts.check(`12px ${this.getFontConfig().family}`)) {
                    let fontCheckInterval = setInterval(() => {
                        if (document.fonts.check(`12px ${this.getFontConfig().family}`)) {
                            update();
                            clearInterval(fontCheckInterval);
                        }
                    }, 1000);
                }
            }
        });
    }

    getValues() {
        return {
            noEngraving: this.noEngravingIsChecked(),
            text: this.textOption.value,
            fontConfig: this.getFontConfig()
        };
    }

    noEngravingIsChecked() {
        return this.noEngravingOption && this.noEngravingOption.checked;
    }

    getFontConfig() {
        if (!this.fontConfig) {
            this.setFontConfig();
        }

        return this.fontConfig;
    }

    setFontConfig() {
        const selectedFont = Array.from(this.fontOptions).find(fontOption => fontOption.checked).value;
        this.fontConfig = this.builder.config.fonts.find(font => selectedFont === font.family);
    }

    updateText(text) {
        const emoticons = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
        let allowedText = text.replace(emoticons, '');
        const allowedExpression = /[^a-zA-Z0-9\-._+]/i;
        allowedText = allowedText.replace(allowedExpression, '');

        if (allowedText !== text) {
            this.textOption.value = allowedText;
        }
    }
}

customElements.define('engravable-options', EngravableOptions);

class LoveCompassOptions extends EngravableOptions {
    initialize() {
        this.cardinalValues = {};
        this.cardinalInputs = this.querySelectorAll('input[data-cardinal]');
        this.cardinalInputs.forEach(input => {
            this.cardinalValues[input.dataset.cardinal] = this.getValidCardinal(input.value);
            input.addEventListener('focus', event => this.removeCardinal(event.target));
            input.addEventListener('input', event => this.changeCardinal(event.target));
            input.addEventListener('blur', event => this.restoreCardinal(event.target));
            input.addEventListener('change', event => this.restoreCardinal(event.target));
        });
        super.initialize();
    }

    setFontConfig() {
        this.fontConfig = this.builder.config.fonts[0];
    }

    updateText() {
        // overwriting the parent method
    }

    getValidCardinal(value) {
        value = value.trim().toUpperCase().replace(/\n/g, '').replaceAll(' ', '');
        if (value.length !== 1) {
            const characters = value.split('');
            value = characters.pop();
        }

        return value && value.match(/^[A-Z0-9]$/i) ? value : null;
    }

    removeCardinal(input) {
        input.value = '';
    }

    restoreCardinal(input) {
        if (!input.value.trim()) {
            input.value = this.cardinalValues[input.dataset.cardinal];
        }
    }

    changeCardinal(input) {
        const value = this.getValidCardinal(input.value);
        if (value) {
            input.value = value;
            this.cardinalValues[input.dataset.cardinal] = value;
            this.changeEngravingText();
        } else {
            input.value = '';
        }
    }

    changeEngravingText() {
        const cardinals = this.cardinalValues;
        this.textOption.value = `${cardinals.N}, ${cardinals.E}, ${cardinals.S}, ${cardinals.W}`;
        this.textOption.dispatchEvent(new Event('input'));
    }
}

customElements.define('love-compass-options', LoveCompassOptions);

class EngravableForm extends HTMLElement {
    connectedCallback() {
        this.builder = this.closest('engravable-builder');

        this.addEventListener('submit', this.submitForm.bind(this));
        this.builder.addEventListener('engravableVariantChanged', this.handleVariantChanged.bind(this));
        this.builder.addEventListener('engravableOptionsChanged', this.handleOptionsChanged.bind(this));
        this.builder.addEventListener('engravableOptionsComputed', this.handleOptionsComputed.bind(this));
    }

    submitForm(event) {
        event.preventDefault();

        if (this.getAddToCartButton().classList.contains('loading')) {
            return;
        }

        const cart = document.getElementById('CartDrawer');
        const formData = new FormData(this.querySelector('form'));
        const valid = this.validate(formData);
        if (!valid) {
            return;
        }

        formData.append('sections', cart.getSectionIdsToRender().join(','));
        formData.append('sections_url', BryanAnthonys.pagePath());
        formData.append('id', formData.get('engravable_variant_id'));

        this.getAddToCartButton().classList.add('loading');

        this.builder.querySelector('[data-preview-canvas]')
            .toBlob(engravingPreviewBlob => {
                formData.append('properties[Engraving Preview]', engravingPreviewBlob);

                if (formData.get('properties[Engraving]') !== 'no engraving') {
                    const svg = this.builder.querySelector('engravable-svg-rendering').getSvgRenderingWrapper().innerHTML;
                    formData.append(
                        'properties[_SVG Source]',
                        new Blob([svg], {type: 'image/svg+xml'})
                    );
                }

                BryanAnthonys.cart.add(formData, 'pdp')
                    .then(response => {
                        cart.renderContents(response);
                        this.closest('modal-dialog').hide();
                    })
                    .catch(error => alert('There has been an error: ' + error))
                    .finally(() => this.getAddToCartButton().classList.remove('loading'));
            }, 'image/png');
    }

    validate(formData) {
        if (!formData.get('engravable_variant_id')) {
            return false;
        }

        this.removeValidationErrors();

        if (!formData.get('properties[Engraving]')) {
            this.insertAdjacentHTML('beforeend', `
                <div class="error pt-1 pb-1" aria-live="polite" data-temp-form-element data-temp-validation-error>
                    Please input engraving text or select the no engraving option.
                </div>
            `);

            return false;
        }

        this.querySelectorAll('[data-temp-checkbox-feedback]').forEach(element => element.remove());
        for (const checkbox of this.querySelectorAll('[data-mandatory-checkbox]')) {
            if (checkbox.checked) {
                continue;
            }

            const label = checkbox.closest('label');

            label.insertAdjacentHTML('afterend', `
                <div class="error pt-1 pb-1" aria-live="polite" data-temp-checkbox-feedback data-temp-validation-error>
                    Please select the above checkbox
                </div>
            `);

            const intro = label.querySelector('.engravable-form__agreements-intro');
            if (intro) {
                intro.insertAdjacentHTML('beforeend', `
                    <span class="animated-pointed-up-hand" data-temp-checkbox-animated-feedback>☝️</span>
                `);
                setTimeout(() => label.querySelectorAll('[data-temp-checkbox-animated-feedback]')
                    .forEach(element => element.remove()), 5000);
            }

            return false;
        }

        return true;
    }

    handleVariantChanged(event) {
        const variant = event.detail.variant;

        if (!variant || !variant.available) {
            this.getAddToCartButton().setAttribute('disabled', '');
        } else {
            this.getAddToCartButton().removeAttribute('disabled');
            this.querySelector('[name="engravable_variant_id"]').value = variant.id;
        }
    }

    handleOptionsChanged(event) {
        if (event.detail.options.noEngraving) {
            this.removeTempElements();
            this.querySelector('form').insertAdjacentHTML('beforeend', `
                <input type="hidden" name="properties[Engraving]" value="no engraving" data-temp-form-element />
            `);
        }
    }

    handleOptionsComputed(event) {
        this.removeTempElements();
        const text = event.detail.acceptedText.acceptedText;
        const height = event.detail.acceptedText.size.size;
        const font = event.detail.options.fontConfig.title;

        const form = this.querySelector('form');
        form.insertAdjacentHTML('beforeend', `
            <input type="hidden" name="properties[Engraving]" data-temp-form-element />
            <input type="hidden" name="properties[_letterHeight]" data-temp-form-element />
            <input type="hidden" name="properties[Font]" data-temp-form-element />
        `);
        form.querySelector('[name="properties[Engraving]"]').value = text;
        form.querySelector('[name="properties[_letterHeight]"]').value = height;
        form.querySelector('[name="properties[Font]"]').value = font;
    }

    removeTempElements() {
        this.querySelectorAll('[data-temp-form-element]')
            .forEach(property => property.remove());
    }

    removeValidationErrors() {
        this.querySelectorAll('[data-temp-validation-error]')
            .forEach(property => property.remove());
    }

    getAddToCartButton() {
        return this.querySelector('[data-add-to-cart-button]');
    }
}

customElements.define('engravable-form', EngravableForm);

class EngravableAgreements extends HTMLElement {
    connectedCallback() {
        this.addEventListener('change', () => {
            this.querySelectorAll('[data-temp-checkbox-feedback]')
                .forEach(element => element.remove());
        });
    }
}

customElements.define('engravable-agreements', EngravableAgreements);

class EngravableSwatches extends HTMLElement {
    connectedCallback() {
        const builder = this.closest('engravable-builder');

        this.addEventListener('swatchButtonsVariantChanged', event => {
            const variant = event.detail.variant;

            builder.dispatchEvent(new CustomEvent('engravableVariantChanged', {
                bubbles: true,
                detail: {variant}
            }));

            this.querySelectorAll('[data-variant-specific]')
                .forEach(element => element.remove());

            if (!variant || !variant.available) {
                const text = !variant ? 'Selection is unavailable' : `${variant.title} is out of stock`;

                let backInStock = '';
                if (variant) {
                    backInStock = `
                        <back-in-stock-opener 
                            data-product-name=${JSON.stringify(builder.product.title)}
                            data-variant-id="${parseInt(variant.id)}"
                        >
                            <button type="button" class="button button--small uppercase mr-2">
                                Notify me 
                            </button>
                        </back-in-stock-opener>
                    `;
                }

                this.insertAdjacentHTML('beforeend', BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(`
                    <div class="mt-3 flex w-100 align-items-center" data-variant-specific>
                        ${backInStock}
                        <span class="badge inline-block size-14 p-1">${text}</span>
                    </div>
                `)));
            }
        });
    }
}

customElements.define('engravable-swatches', EngravableSwatches);

class EngravableElementInitializer extends HTMLElement {
    connectedCallback() {
        if (typeof this.parentElement.initialize === 'function') {
            this.parentElement.initialize();
        }
    }
}

customElements.define('engravable-element-initializer', EngravableElementInitializer);

BryanAnthonys.showEngravablePreview = function (productHandle, variantId, imageUrl) {
    document.querySelectorAll('#shopify-section-engravables-preview')
        .forEach(modal => modal.remove());

    return new Promise(function (resolve, reject) {
        fetch(`/products/${productHandle}?variant=${variantId}&section_id=engravables-preview`)
            .then(BryanAnthonys.decodeTextResponse)
            .then(html => {
                document.body.insertAdjacentHTML('beforeend', BryanAnthonys.htmlReviewedForSafety(html));
                const modal = document.getElementById('EngravablePreviewModal');
                modal.querySelector('[data-engravable-pendant]').src = imageUrl;
                modal.show();
            })
            .catch(reject)
            .finally(() => resolve());
    });
};